/* eslint-disable max-len */
import 'react';

let index = 0;

const DataSheetSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const date = index++;
    const id = `datasheet-1-${date}`;
    const id2 = `datasheet-2-${date}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 48 48" {...props}>
            <defs>
                <linearGradient
                    x1="85.446%"
                    y1="50%"
                    x2="14.554%"
                    y2="0%"
                    id={id}
                >
                    <stop stopColor="#758BFF" offset="0%" />
                    <stop stopColor="#8AB6FF" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="0%"
                    y1="2.409%"
                    x2="100%"
                    y2="97.591%"
                    id={id2}
                >
                    <stop stopColor="#FFF" stopOpacity={0.96} offset="0%" />
                    <stop stopColor="#FFF" stopOpacity={0.8} offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h48v48H0z" />
                <path
                    d="M1.996 0h21.999a9.391 9.391 0 019.391 9.391v25.27a4.99 4.99 0 01-4.99 4.991H4.99A4.99 4.99 0 010 34.662V1.996C0 .894.894 0 1.996 0z"
                    fill={`url(#${id})`}
                    transform="translate(7 4)"
                />
                <path
                    d="M9.661 18.778c.918 0 1.661.743 1.661 1.66v8.234a1.661 1.661 0 11-3.322 0V20.44c0-.918.744-1.661 1.661-1.661zM16.883 13c.918 0 1.661.744 1.661 1.661v14.011a1.661 1.661 0 11-3.322 0v-14.01c0-.918.744-1.662 1.661-1.662zm7.223 8.667c.917 0 1.66.743 1.66 1.66v5.345a1.661 1.661 0 11-3.322 0v-5.344c0-.918.744-1.661 1.662-1.661z"
                    fill={`url(#${id2})`}
                    transform="translate(7 4)"
                />
            </g>
        </svg>
    );
};

export default DataSheetSvg;
